/**
 * Single source of truth for the lobby board stage cadence.
 *
 * `LobbyBoardStage` mounts two slots simultaneously during a board
 * navigation: the outgoing slot keeps painting at opacity 1 while the
 * incoming slot mounts offscreen at opacity 0, runs its data fetch +
 * forfeit baseline + first paint, and only then cuts over (an instant
 * hard swap — no fade, no audio).
 *
 *  - `BOARD_PRELOAD_TIMEOUT_MS` is the hard ceiling on how long the
 *    incoming slot can sit at opacity 0 waiting for its readiness
 *    gate. Past this we cut over anyway so a stuck indexer / network
 *    hiccup can't wedge the user on the outgoing board. 2 s is
 *    comfortably under any "did the click register?" threshold while
 *    still giving warm-cache hits + cold-start fetches plenty of room.
 */
export const BOARD_PRELOAD_TIMEOUT_MS = 2000;
